// extracted by mini-css-extract-plugin
export default {"label":"quota-modal_label__Rt5iW","inputField":"quota-modal_inputField__FDZ9r","loading":"quota-modal_loading__g9CV6"};